import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type { UpdateMalwareRevisionReportRequest } from '../../../../shared/types/routes/internalTools/malwareReport';

function updateMalwareReport({
  id, malwareData,
}: { id: number; malwareData: UpdateMalwareRevisionReportRequest }): Promise<Response> {
  return put<UpdateMalwareRevisionReportRequest, void>(`/api/internal-tools/malware/${id}`, malwareData);
}

/**
 * Hook to update an existing malware report
 */
export default function useUpdateMalwareReport() {
  return useToastedMutation({
    mutationFn: updateMalwareReport,
    successToastMessage: 'Malware report updated successfully',
    errorToastMessage: 'Failed to update malware report.',
    onSuccess: () => {
      // Invalidate and refetch malware reports
      queryClient.invalidateQueries({ queryKey: ['malware'] });
    },
  });
}
